import Vue from 'vue';
import PortalVue from 'portal-vue';
import x5GMaps from 'x5-gmaps';
import Sticky from 'vue-sticky-directive';
import 'sharer.js';

Vue.use( x5GMaps, 'AIzaSyBUjnuFeFID8kESGKd4mAg58ovrLPwSMn8' );
Vue.use( PortalVue );
Vue.use( Sticky );

import './styles/base.css';
import './styles/components.css';
import App from './App.vue';

Vue.config.productionTip = false;

new Vue( App ).$mount( '#app' );
